// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* games/game2048/Game2048.css */

:root {
  --g2048-bg: #1e1e2e;
  --g2048-grid-bg: #2b2b40;
  --g2048-cell-empty: #3a3a55;
  --g2048-gap: 8px; /* Размер отступа между плитками */
  --g2048-text-light: #e0e0e0;
  --g2048-accent: #fbbf24;
}

.g2048-board {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: linear-gradient(135deg, #111119 0%, #1e1e2e 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 6000;
  font-family: 'Courier New', monospace;
  overflow: hidden;
  -webkit-user-select: none;
          user-select: none;
}

/* --- HEADER --- */
.g2048-header {
  width: 90vmin; /* Адаптивная ширина */
  max-width: 500px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 10px;
}

.g2048-score-box {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 8px 12px;
  min-width: 80px;
  text-align: center;
  backdrop-filter: blur(4px);
}

.g2048-score-box.timer-box {
  border-color: rgba(251, 191, 36, 0.4); /* Золотистая рамка для таймера */
  background: rgba(251, 191, 36, 0.05);
}

.g2048-label {
  font-size: 11px;
  font-weight: 700;
  color: #8f92a1;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 4px;
}

.g2048-value {
  font-size: 20px;
  font-weight: 900;
  color: #fff;
}

.timer-box .g2048-value {
  color: var(--g2048-accent);
}

/* --- GRID CONTAINER --- */
.g2048-grid-container {
  position: relative;
  width: 90vmin;
  height: 90vmin;
  max-width: 500px;
  max-height: 500px;
  background: var(--g2048-grid-bg);
  border-radius: 12px;
  padding: var(--g2048-gap); /* Внешний отступ равен внутренним */
  box-sizing: border-box;
  box-shadow: 0 10px 30px rgba(0,0,0,0.5);
  font-family: "Clear Sans", "Helvetica Neue", Arial, sans-serif;
  font-weight: 700;
}

/* --- BACKGROUND GRID --- */
.g2048-grid-background {
  width: 100%;
  height: 100%;
  display: grid;
  /* gap не нужен, так как отступы делаем через padding внутри ячеек */
}

.g2048-cell-placeholder {
  width: 100%;
  height: 100%;
  padding: calc(var(--g2048-gap) / 2); /* Половина отступа с каждой стороны */
  box-sizing: border-box;
}

.g2048-cell-inner {
  width: 100%;
  height: 100%;
  background: var(--g2048-cell-empty);
  border-radius: 6px;
}

/* --- TILE LAYER --- */
.g2048-tile-layer {
  position: absolute;
  top: var(--g2048-gap);
  left: var(--g2048-gap);
  right: var(--g2048-gap);
  bottom: var(--g2048-gap);
  /* Этот слой совпадает по размеру с контентом сетки */
}

.g2048-tile-wrapper {
  position: absolute;
  top: 0; left: 0;
  box-sizing: border-box;
  padding: calc(var(--g2048-gap) / 2); /* или ваш gap */

  /* АНИМАЦИЯ ДВИЖЕНИЯ */
  /* 200ms - время полета. Должно совпадать с таймером в JS (setTimeout) */
  transition: transform 0.10s ease-in-out;
  will-change: transform;
}

/* --- TILE CONTENT & FONTS --- */
.g2048-tile-inner {
  width: 100%;
  height: 100%;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 550; /* Жирный шрифт для красоты */
  color: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);

  /* Элегантная логика размеров:
     Используем clamp(), чтобы шрифт был крупным, но не ломался на совсем малых экранах
  */
  transition: font-size 0.2s ease; /* Плавное уменьшение шрифта при росте числа */
}

/* 1 и 2 цифры (числа 2, 4, 8, 16, 32, 64) - ОЧЕНЬ КРУПНО */
.g2048-tile-inner,
.g2048-tile-inner[data-digits="1"],
.g2048-tile-inner[data-digits="2"] {
  font-size: clamp(2rem, 12vmin, 3.4rem); /* Мин 32px, Макс ~60px */
}

/* 3 цифры (числа 128, 256, 512) - СРЕДНЕ */
.g2048-tile-inner[data-digits="3"] {
  font-size: clamp(1.5rem, 9vmin, 2.8rem); /* Уменьшаем, чтобы влезло */
}

/* 4 цифры (числа 1024, 2048, 4096, 8192) - КОМПАКТНО */
.g2048-tile-inner[data-digits="4"] {
  font-size: clamp(1.2rem, 7vmin, 2.2rem);
}

/* 5 и более цифр (16384+) - МЕЛКО */
.g2048-tile-inner[data-digits="5"],
.g2048-tile-inner[data-digits="6"] {
  font-size: clamp(1rem, 5vmin, 1.6rem);
}

/* --- TILE COLORS (Cyber/Dark Theme) --- */
.tile-2    { background: #e0e0e0; color: #333; }
.tile-4    { background: #a8dadc; color: #333; }
.tile-8    { background: #457b9d; }
.tile-16   { background: #1d3557; }
.tile-32   { background: #e63946; }
.tile-64   { background: #d62828; }
.tile-128  { background: #f77f00; box-shadow: 0 0 10px rgba(247, 127, 0, 0.4); }
.tile-256  { background: #fcbf49; color: #333; box-shadow: 0 0 10px rgba(252, 191, 73, 0.4); }
.tile-512  { background: #eae2b7; color: #333; box-shadow: 0 0 15px rgba(234, 226, 183, 0.5); }
.tile-1024 { background: #00b4d8; box-shadow: 0 0 15px rgba(0, 180, 216, 0.5); }
.tile-2048 {
  background: #7209b7;
  box-shadow: 0 0 20px rgba(114, 9, 183, 0.6);
  animation: pulse-glow 2s infinite;
}
.tile-super { background: #3a0ca3; }

/* --- ANIMATIONS --- */
@keyframes pulse-glow {
  0% { box-shadow: 0 0 15px rgba(114, 9, 183, 0.6); }
  50% { box-shadow: 0 0 25px rgba(181, 23, 158, 0.8); }
  100% { box-shadow: 0 0 15px rgba(114, 9, 183, 0.6); }
}

/* Обновляем класс .new */
.g2048-tile-inner.new {
  animation: appear 0.2s ease-out backwards;
}

.g2048-tile-inner.merged {
  animation: pop 0.2s ease-out backwards; /* 0.15s delay */
}

@keyframes appear {
  0% { transform: scale(0); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}

@keyframes pop {
  0% { transform: scale(1); }
  50% { transform: scale(1.15); filter: brightness(1.2); }
  100% { transform: scale(1); }
}

/* --- OVERLAY (FINAL SCREEN) --- */
.g2048-result-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  /* Полупрозрачный фон с размытием */
  background: rgba(10, 10, 15, 0.85);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 7000;
  animation: fadeOverlay 0.4s ease-out;
  padding: 20px;
}

/* Карточка отчета */
.g2048-result-card {
  width: 100%;
  max-width: 340px;
  background: #1f2937; /* Темно-серый блок */
  border: 1px solid #374151;
  border-radius: 16px;
  box-shadow:
    0 20px 25px -5px rgba(0, 0, 0, 0.5),
    0 8px 10px -6px rgba(0, 0, 0, 0.5);
  padding: 24px;
  text-align: center;
  position: relative;
  overflow: hidden;
  animation: slideUp 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

/* Декоративная полоса сверху */
.g2048-result-card::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 6px;
  background: linear-gradient(90deg, #fbbf24, #d97706);
}

.g2048-game-over-text {
  font-size: 26px;
  font-weight: 900;
  color: #f3f4f6;
  margin-top: 10px;
  margin-bottom: 5px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Ранг игрока */
.g2048-rank {
  font-size: 18px;
  color: #fbbf24; /* Amber */
  margin-bottom: 25px;
  font-weight: 600;
  text-transform: uppercase;
  opacity: 0.9;
}

/* Контейнер статистики (панель) */
.g2048-stats-panel {
  display: flex;
  background: #111827; /* Еще темнее внутри */
  border-radius: 12px;
  padding: 15px 0;
  margin-bottom: 25px;
  border: 1px solid #374151;
}

.g2048-stat-item {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}

/* Разделитель между статистикой */
.g2048-stat-item:first-child::after {
  content: '';
  position: absolute;
  right: 0;
  top: 10%;
  height: 80%;
  width: 1px;
  background: #374151;
}

.g2048-stat-label {
  font-size: 11px;
  text-transform: uppercase;
  color: #9ca3af; /* Gray 400 */
  letter-spacing: 1px;
  margin-bottom: 4px;
  font-weight: 700;
}

.g2048-stat-value {
  font-size: 28px;
  font-weight: 800;
  color: #fff;
  font-variant-numeric: tabular-nums; /* Моноширинные цифры */
}

/* Кнопка выхода */
.g2048-btn {
  background: #fbbf24;
  color: #111827;
  border: none;
  padding: 16px 0;
  width: 100%;
  font-size: 16px;
  font-weight: 800;
  border-radius: 10px;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: transform 0.1s, background-color 0.2s;
  box-shadow: 0 4px 0 #b45309;
}

.g2048-btn:hover {
  background: #fcd34d;
}

.g2048-btn:active {
  transform: translateY(2px);
  box-shadow: 0 2px 0 #b45309;
}

@keyframes fadeOverlay {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}`, "",{"version":3,"sources":["webpack://./src/components/arcade/games/game2048/Game2048.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC;EACE,mBAAmB;EACnB,wBAAwB;EACxB,2BAA2B;EAC3B,gBAAgB,EAAE,kCAAkC;EACpD,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,WAAW,EAAE,YAAY;EAC1C,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,aAAa,EAAE,sBAAsB;EACrC,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC,EAAE,iCAAiC;EACxE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,yBAAyB,EAAE,oCAAoC;EAC/D,sBAAsB;EACtB,uCAAuC;EACvC,8DAA8D;EAC9D,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oEAAoE;AACtE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC,EAAE,sCAAsC;EAC3E,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO;EACf,sBAAsB;EACtB,mCAAmC,EAAE,gBAAgB;;EAErD,sBAAsB;EACtB,wEAAwE;EACxE,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB,EAAE,6BAA6B;EAC/C,WAAW;EACX,qCAAqC;;EAErC;;GAEC;EACD,+BAA+B,EAAE,8CAA8C;AACjF;;AAEA,2DAA2D;AAC3D;;;EAGE,sCAAsC,EAAE,yBAAyB;AACnE;;AAEA,2CAA2C;AAC3C;EACE,uCAAuC,EAAE,4BAA4B;AACvE;;AAEA,uDAAuD;AACvD;EACE,uCAAuC;AACzC;;AAEA,oCAAoC;AACpC;;EAEE,qCAAqC;AACvC;;AAEA,2CAA2C;AAC3C,aAAa,mBAAmB,EAAE,WAAW,EAAE;AAC/C,aAAa,mBAAmB,EAAE,WAAW,EAAE;AAC/C,aAAa,mBAAmB,EAAE;AAClC,aAAa,mBAAmB,EAAE;AAClC,aAAa,mBAAmB,EAAE;AAClC,aAAa,mBAAmB,EAAE;AAClC,aAAa,mBAAmB,EAAE,2CAA2C,EAAE;AAC/E,aAAa,mBAAmB,EAAE,WAAW,EAAE,4CAA4C,EAAE;AAC7F,aAAa,mBAAmB,EAAE,WAAW,EAAE,6CAA6C,EAAE;AAC9F,aAAa,mBAAmB,EAAE,2CAA2C,EAAE;AAC/E;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,iCAAiC;AACnC;AACA,cAAc,mBAAmB,EAAE;;AAEnC,uBAAuB;AACvB;EACE,KAAK,2CAA2C,EAAE;EAClD,MAAM,4CAA4C,EAAE;EACpD,OAAO,2CAA2C,EAAE;AACtD;;AAEA,yBAAyB;AACzB;EACE,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC,EAAE,gBAAgB;AAC1D;;AAEA;EACE,KAAK,mBAAmB,EAAE,UAAU,EAAE;EACtC,OAAO,mBAAmB,EAAE,UAAU,EAAE;AAC1C;;AAEA;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,sBAAsB,EAAE,uBAAuB,EAAE;EACvD,OAAO,mBAAmB,EAAE;AAC9B;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,mCAAmC;EACnC,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,oCAAoC;EACpC,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB,EAAE,qBAAqB;EAC1C,yBAAyB;EACzB,mBAAmB;EACnB;;sCAEoC;EACpC,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,+DAA+D;AACjE;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,cAAc,EAAE,UAAU;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;AACd;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB,EAAE,sBAAsB;EAC3C,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc,EAAE,aAAa;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kCAAkC,EAAE,uBAAuB;AAC7D;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,iDAAiD;EACjD,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C","sourcesContent":["/* games/game2048/Game2048.css */\n\n:root {\n  --g2048-bg: #1e1e2e;\n  --g2048-grid-bg: #2b2b40;\n  --g2048-cell-empty: #3a3a55;\n  --g2048-gap: 8px; /* Размер отступа между плитками */\n  --g2048-text-light: #e0e0e0;\n  --g2048-accent: #fbbf24;\n}\n\n.g2048-board {\n  position: fixed;\n  top: 0; left: 0; width: 100%; height: 100%;\n  background: linear-gradient(135deg, #111119 0%, #1e1e2e 100%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 6000;\n  font-family: 'Courier New', monospace;\n  overflow: hidden;\n  user-select: none;\n}\n\n/* --- HEADER --- */\n.g2048-header {\n  width: 90vmin; /* Адаптивная ширина */\n  max-width: 500px;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  gap: 10px;\n}\n\n.g2048-score-box {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  padding: 8px 12px;\n  min-width: 80px;\n  text-align: center;\n  backdrop-filter: blur(4px);\n}\n\n.g2048-score-box.timer-box {\n  border-color: rgba(251, 191, 36, 0.4); /* Золотистая рамка для таймера */\n  background: rgba(251, 191, 36, 0.05);\n}\n\n.g2048-label {\n  font-size: 11px;\n  font-weight: 700;\n  color: #8f92a1;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 4px;\n}\n\n.g2048-value {\n  font-size: 20px;\n  font-weight: 900;\n  color: #fff;\n}\n\n.timer-box .g2048-value {\n  color: var(--g2048-accent);\n}\n\n/* --- GRID CONTAINER --- */\n.g2048-grid-container {\n  position: relative;\n  width: 90vmin;\n  height: 90vmin;\n  max-width: 500px;\n  max-height: 500px;\n  background: var(--g2048-grid-bg);\n  border-radius: 12px;\n  padding: var(--g2048-gap); /* Внешний отступ равен внутренним */\n  box-sizing: border-box;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.5);\n  font-family: \"Clear Sans\", \"Helvetica Neue\", Arial, sans-serif;\n  font-weight: 700;\n}\n\n/* --- BACKGROUND GRID --- */\n.g2048-grid-background {\n  width: 100%;\n  height: 100%;\n  display: grid;\n  /* gap не нужен, так как отступы делаем через padding внутри ячеек */\n}\n\n.g2048-cell-placeholder {\n  width: 100%;\n  height: 100%;\n  padding: calc(var(--g2048-gap) / 2); /* Половина отступа с каждой стороны */\n  box-sizing: border-box;\n}\n\n.g2048-cell-inner {\n  width: 100%;\n  height: 100%;\n  background: var(--g2048-cell-empty);\n  border-radius: 6px;\n}\n\n/* --- TILE LAYER --- */\n.g2048-tile-layer {\n  position: absolute;\n  top: var(--g2048-gap);\n  left: var(--g2048-gap);\n  right: var(--g2048-gap);\n  bottom: var(--g2048-gap);\n  /* Этот слой совпадает по размеру с контентом сетки */\n}\n\n.g2048-tile-wrapper {\n  position: absolute;\n  top: 0; left: 0;\n  box-sizing: border-box;\n  padding: calc(var(--g2048-gap) / 2); /* или ваш gap */\n\n  /* АНИМАЦИЯ ДВИЖЕНИЯ */\n  /* 200ms - время полета. Должно совпадать с таймером в JS (setTimeout) */\n  transition: transform 0.10s ease-in-out;\n  will-change: transform;\n}\n\n/* --- TILE CONTENT & FONTS --- */\n.g2048-tile-inner {\n  width: 100%;\n  height: 100%;\n  border-radius: 6px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 550; /* Жирный шрифт для красоты */\n  color: #fff;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n\n  /* Элегантная логика размеров:\n     Используем clamp(), чтобы шрифт был крупным, но не ломался на совсем малых экранах\n  */\n  transition: font-size 0.2s ease; /* Плавное уменьшение шрифта при росте числа */\n}\n\n/* 1 и 2 цифры (числа 2, 4, 8, 16, 32, 64) - ОЧЕНЬ КРУПНО */\n.g2048-tile-inner,\n.g2048-tile-inner[data-digits=\"1\"],\n.g2048-tile-inner[data-digits=\"2\"] {\n  font-size: clamp(2rem, 12vmin, 3.4rem); /* Мин 32px, Макс ~60px */\n}\n\n/* 3 цифры (числа 128, 256, 512) - СРЕДНЕ */\n.g2048-tile-inner[data-digits=\"3\"] {\n  font-size: clamp(1.5rem, 9vmin, 2.8rem); /* Уменьшаем, чтобы влезло */\n}\n\n/* 4 цифры (числа 1024, 2048, 4096, 8192) - КОМПАКТНО */\n.g2048-tile-inner[data-digits=\"4\"] {\n  font-size: clamp(1.2rem, 7vmin, 2.2rem);\n}\n\n/* 5 и более цифр (16384+) - МЕЛКО */\n.g2048-tile-inner[data-digits=\"5\"],\n.g2048-tile-inner[data-digits=\"6\"] {\n  font-size: clamp(1rem, 5vmin, 1.6rem);\n}\n\n/* --- TILE COLORS (Cyber/Dark Theme) --- */\n.tile-2    { background: #e0e0e0; color: #333; }\n.tile-4    { background: #a8dadc; color: #333; }\n.tile-8    { background: #457b9d; }\n.tile-16   { background: #1d3557; }\n.tile-32   { background: #e63946; }\n.tile-64   { background: #d62828; }\n.tile-128  { background: #f77f00; box-shadow: 0 0 10px rgba(247, 127, 0, 0.4); }\n.tile-256  { background: #fcbf49; color: #333; box-shadow: 0 0 10px rgba(252, 191, 73, 0.4); }\n.tile-512  { background: #eae2b7; color: #333; box-shadow: 0 0 15px rgba(234, 226, 183, 0.5); }\n.tile-1024 { background: #00b4d8; box-shadow: 0 0 15px rgba(0, 180, 216, 0.5); }\n.tile-2048 {\n  background: #7209b7;\n  box-shadow: 0 0 20px rgba(114, 9, 183, 0.6);\n  animation: pulse-glow 2s infinite;\n}\n.tile-super { background: #3a0ca3; }\n\n/* --- ANIMATIONS --- */\n@keyframes pulse-glow {\n  0% { box-shadow: 0 0 15px rgba(114, 9, 183, 0.6); }\n  50% { box-shadow: 0 0 25px rgba(181, 23, 158, 0.8); }\n  100% { box-shadow: 0 0 15px rgba(114, 9, 183, 0.6); }\n}\n\n/* Обновляем класс .new */\n.g2048-tile-inner.new {\n  animation: appear 0.2s ease-out backwards;\n}\n\n.g2048-tile-inner.merged {\n  animation: pop 0.2s ease-out backwards; /* 0.15s delay */\n}\n\n@keyframes appear {\n  0% { transform: scale(0); opacity: 0; }\n  100% { transform: scale(1); opacity: 1; }\n}\n\n@keyframes pop {\n  0% { transform: scale(1); }\n  50% { transform: scale(1.15); filter: brightness(1.2); }\n  100% { transform: scale(1); }\n}\n\n/* --- OVERLAY (FINAL SCREEN) --- */\n.g2048-result-overlay {\n  position: absolute;\n  top: 0; left: 0; right: 0; bottom: 0;\n  /* Полупрозрачный фон с размытием */\n  background: rgba(10, 10, 15, 0.85);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 7000;\n  animation: fadeOverlay 0.4s ease-out;\n  padding: 20px;\n}\n\n/* Карточка отчета */\n.g2048-result-card {\n  width: 100%;\n  max-width: 340px;\n  background: #1f2937; /* Темно-серый блок */\n  border: 1px solid #374151;\n  border-radius: 16px;\n  box-shadow:\n    0 20px 25px -5px rgba(0, 0, 0, 0.5),\n    0 8px 10px -6px rgba(0, 0, 0, 0.5);\n  padding: 24px;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n  animation: slideUp 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n\n/* Декоративная полоса сверху */\n.g2048-result-card::before {\n  content: '';\n  position: absolute;\n  top: 0; left: 0; right: 0;\n  height: 6px;\n  background: linear-gradient(90deg, #fbbf24, #d97706);\n}\n\n.g2048-game-over-text {\n  font-size: 26px;\n  font-weight: 900;\n  color: #f3f4f6;\n  margin-top: 10px;\n  margin-bottom: 5px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n/* Ранг игрока */\n.g2048-rank {\n  font-size: 18px;\n  color: #fbbf24; /* Amber */\n  margin-bottom: 25px;\n  font-weight: 600;\n  text-transform: uppercase;\n  opacity: 0.9;\n}\n\n/* Контейнер статистики (панель) */\n.g2048-stats-panel {\n  display: flex;\n  background: #111827; /* Еще темнее внутри */\n  border-radius: 12px;\n  padding: 15px 0;\n  margin-bottom: 25px;\n  border: 1px solid #374151;\n}\n\n.g2048-stat-item {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n/* Разделитель между статистикой */\n.g2048-stat-item:first-child::after {\n  content: '';\n  position: absolute;\n  right: 0;\n  top: 10%;\n  height: 80%;\n  width: 1px;\n  background: #374151;\n}\n\n.g2048-stat-label {\n  font-size: 11px;\n  text-transform: uppercase;\n  color: #9ca3af; /* Gray 400 */\n  letter-spacing: 1px;\n  margin-bottom: 4px;\n  font-weight: 700;\n}\n\n.g2048-stat-value {\n  font-size: 28px;\n  font-weight: 800;\n  color: #fff;\n  font-variant-numeric: tabular-nums; /* Моноширинные цифры */\n}\n\n/* Кнопка выхода */\n.g2048-btn {\n  background: #fbbf24;\n  color: #111827;\n  border: none;\n  padding: 16px 0;\n  width: 100%;\n  font-size: 16px;\n  font-weight: 800;\n  border-radius: 10px;\n  cursor: pointer;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  transition: transform 0.1s, background-color 0.2s;\n  box-shadow: 0 4px 0 #b45309;\n}\n\n.g2048-btn:hover {\n  background: #fcd34d;\n}\n\n.g2048-btn:active {\n  transform: translateY(2px);\n  box-shadow: 0 2px 0 #b45309;\n}\n\n@keyframes fadeOverlay {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideUp {\n  from { transform: translateY(20px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
